const help_center_data = [
	{
		id: '0Getting started',
		title: 'Getting started',
		text: 'Learn how to create an account, set up your wallet, and what you can do.',
	},
	{
		id: '1Buying',
		title: 'Buying',
		text: 'Learn how to create an account, set up your wallet, and what you can do.',
	},
	{
		id: '2Selling',
		title: 'Selling',
		text: 'Learn how to create an account, set up your wallet, and what you can do.',
	},
	{
		id: '3Creating',
		title: 'Creating',
		text: 'Learn how to create an account, set up your wallet, and what you can do.',
	},
	{
		id: '4User Safety',
		title: 'User Safety',
		text: 'Learn how to create an account, set up your wallet, and what you can do.',
	},
	{
		id: '5Partners',
		title: 'Partners',
		text: 'Learn how to create an account, set up your wallet, and what you can do.',
	},
];

const accordion_data = [
	{
		id: '1.How can I register a campaign on the platform?',
		title: 'How can I register a campaign on the platform?',
		text: "To register a campaign on our platform, simply navigate to the registration page and follow the prompts to create an account. Once you've logged in, you'll find options to register your campaign, where you can provide all necessary details and materials.",
	},
	{
		id: '2.How do I showcase my work on the platform?',
		title: 'How do I showcase my work on the platform?',
		text: "Showcasing your work is easy! After registering, you can upload your content, whether it's artwork, music, videos, or any other creative project, to your profile. From there, you can customize how you want it to be displayed and shared with the community.",
	},
	{
		id: '3.How can I contribute to campaigns or projects?',
		title: 'How can I contribute to campaigns or projects?',
		text: "Contributing to campaigns is a breeze. Simply browse through the available projects on the platform, find one that interests you, and click on the \"Contribute\" button. You'll then be guided through the contribution process, where you can choose your preferred method of support.",
	},
	{
		id: '4.How can I enter the virtual world featured on the platform?',
		title: 'How can I enter the virtual world featured on the platform?',
		text: "Entering the virtual world is an exciting experience! Once you've registered and logged in, you'll find instructions on how to access the virtual world. This may involve downloading specific software or joining a virtual event, depending on the current offerings.",
	},
	{
		id: '5.Is there a fee for registering a campaign or contributing to projects?',
		title: 'Is there a fee for registering a campaign or contributing to projects?',
		text: "No, there are no fees associated with registering a campaign or contributing to projects on our platform. We believe in providing an accessible space for creators and supporters to connect and collaborate without financial barriers.",
	},
	{
		id: '6.Can I edit or update my campaign after registering it?',
		title: 'Can I edit or update my campaign after registering it?',
		text: "Yes, you can edit and update your campaign at any time. Simply log in to your account, navigate to your campaign's page, and you'll find options to make changes to the content, description, goals, and more.",
	},
	{
		id: '7.What support options are available if I encounter any issues?',
		title: 'What support options are available if I encounter any issues?',
		text: "If you encounter any issues or have questions, our support team is here to help. You can reach out to us through the contact page on our website, and we'll strive to assist you promptly with any inquiries or concerns you may have.",
	},
	{
		id: '8.Are there guidelines or restrictions on the type of content allowed on the platform?',
		title: 'Are there guidelines or restrictions on the type of content allowed on the platform?',
		text: "Yes, we have guidelines in place to ensure a positive and respectful community experience. Please review our terms of service and content guidelines for detailed information on what is and isn't permitted on the platform.",
	},
	{
		id: '9.How can I stay updated on new campaigns, events, and features?',
		title: 'How can I stay updated on new campaigns, events, and features?',
		text: "To stay informed about the latest campaigns, events, and features on our platform, be sure to follow us on social media and subscribe to our newsletter. We regularly share updates and announcements to keep our community engaged and informed.",
	},	
	{
		id: '10.Can I share my campaign or projects on social media?',
		title: 'Can I share my campaign or projects on social media?',
		text: "Absolutely! We encourage creators to share their campaigns and projects on social media to reach a wider audience. You'll find social sharing options available on your campaign's page to make sharing quick and easy.",
	},	
];

export { help_center_data, accordion_data };
